import RoundIconLabelUnit from '@/components/ui/RoundIconLabelUnit/RoundIconLabelUnit';
import Link from 'next/link';
import { TeamListItem } from '../../types';
import styles from './BizTeamList.module.scss';

function BizTeamList({
  teams,
}: {
  teams: Array<TeamListItem>;
}) {
  return (
    <div className={styles.componentStyle}>
      {teams.map((team) => (
        <Link key={team.id} className={styles.item} href={`/e-commerce/biz-team-creator/team/${team.urlSlug}`}>
          <RoundIconLabelUnit iconImageUrl={team.iconUrl} labelText={team.name}></RoundIconLabelUnit>
        </Link>
      ))}
    </div>
  );
}

export default BizTeamList;
